// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__EZ9gs","title":"InfoRow_title__3ORlf"};